var _style, _path, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoison(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#Rectangle-2_1_);}\r\n\t.st1{fill:#FFFFFF;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Types_Poison",
    transform: "translate(10 10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -15, -15)"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Rectangle-2_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 10.6667,
    y1: 61.5333,
    x2: 10.6667,
    y2: 59.1333,
    gradientTransform: "matrix(30 0 0 -30 -284 1846)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#A864C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C261D4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-2",
    className: "st0",
    d: "M36,0L36,0c19.9,0,36,16.1,36,36l0,0c0,19.9-16.1,36-36,36l0,0C16.1,72,0,55.9,0,36l0,0 C0,16.1,16.1,0,36,0z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    className: "st1",
    d: "M28.8,39.2c-1.6-0.1-3.1-1.1-3.8-2.5c-0.7,1.5-2.2,2.5-3.8,2.5c-1.8-0.1-3.4-1.3-4-3 c-0.6,1.7-2.2,2.9-4,3c-2.6,0-4.7-2.9-4.7-6.4c0-0.8,0.1-1.6,0.3-2.3c-3.5-2.8-5.5-7-5.5-11.5c0-8.8,8.1-15.9,18-15.9 s18,7.1,18,15.9c-0.1,4.6-2.3,9-5.9,11.8c0.2,0.6,0.2,1.3,0.2,2C33.5,36.4,31.4,39.2,28.8,39.2z M21,11.3 c-5.9,0-10.7,3.6-10.7,8.1s4.8,8.1,10.7,8.1s10.7-3.6,10.7-8.1S26.8,11.3,21,11.3z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoison);
export default __webpack_public_path__ + "static/media/poison.814204403b91ce0eaf15b952c5d0381a.svg";
export { ForwardRef as ReactComponent };